<div v-if="sphere" :ref="elementId">
	<div class="grid-2">
		<dropdown-editable-frame :id="`type-${elementId}`" :items="sphereTags" :taggable="true" v-model="sphere.type"
			:label="$t('vm.root.patients.patient.sphere.type.label')"
			:no-options-label="$t('vm.root.patients.patient.sphere.type.no-options-label')"
			:error-test="hasTypeError" :error-msg="$t('vm.root.patients.patient.sphere.type.error')"
			:placeholder="$t('vm.root.patients.patient.sphere.type.placeholder')"
			:title="$t('vm.root.patients.patient.sphere.type.title')"/>

		<dropdown-editable-frame :id="`title-${elementId}`" :items="pathologyItems" :taggable="true" v-model="sphere.title"
			:label="$t('vm.root.patients.patient.sphere.title.label')"
			:no-options-label="$t('vm.root.patients.patient.sphere.title.no-options-label')"
			:error-test="hasTitleError" :error-msg="$t('vm.root.patients.patient.sphere.title.error')"
			:placeholder="$t('vm.root.patients.patient.sphere.title.placeholder')"
			:title="$t('vm.root.patients.patient.sphere.title.title')"/>

		<togglebox-frame :id="`state-${elementId}`" :label="$t('vm.root.patients.patient.sphere.state_date.label')" :items="stateItems" v-model="state"/>

		<toggledate-frame v-if="isThereIs" :id="`event-date-1-${elementId}`" :date="toDate" @input="updateTo" :min-date="birthDate"
			:placeholder="$t('vm.root.patients.patient.sphere.there_is_placeholder')" :label="thereIsLabel" />

		<toggledate-frame v-else-if="isAtTheAge" :id="`event-date-2-${elementId}`" :from="birthDate" :date="fromDate" @input="updateFrom" :min-date="birthDate"
			:placeholder="$t('vm.root.patients.patient.sphere.at_the_age_placeholder')" :label="atTheAgeLabel"/>

			<input-date-frame v-else-if="isDate" v-model='eventDate' :id="`event-date-3-${elementId}`" :type="eventDateType" :label="dateLabel"
			:title="$t('vm.root.patients.patient.sphere.date.title')" :placeholder="$t('vm.root.patients.patient.sphere.date.placeholder')"
			:error-test="hasEventDateError" :error-msg="$t('vm.root.patients.patient.sphere.date.error')"/>

		<input-frame v-else type="number" :value='eventYear' @input="updateYear" :id="`event-date-4-${elementId}`" :label="atYearLabel"
			:min="birthDate.getFullYear()" :max="new Date().getFullYear()"
			:title="$t('vm.root.patients.patient.sphere.at_year.title')" 
			:placeholder="$t('vm.root.patients.patient.sphere.at_year.placeholder')"
			:error-test="hasEventDateError" :error-msg="$t('vm.root.patients.patient.sphere.at_year.error')"/>

		<textarea-frame :id="`description-${elementId}`" v-model="sphere.description" class="grid-item-full" rows="2" 
			:label="$t('vm.root.patients.patient.sphere.description.label')" 
			:placeholder="$t('vm.root.patients.patient.sphere.description.placeholder')" 
			:title="$t('vm.root.patients.patient.sphere.description.placeholder')"/>

		<togglebox-frame :id="`important-${elementId}`" :items="importantItems" v-model="sphere.important"
			:label="$t('vm.root.patients.patient.sphere.important_label')"/>
		<togglebox-frame :id="`periodic-${elementId}`" :items="periodictyItems" v-model="sphere.periodic"
			:label="$t('vm.root.patients.patient.sphere.periodicity.label')"/>

		<togglebox-frame v-if="sphere.periodic" :id="`running-${elementId}`" :items="runningItems" v-model="sphere.running"
			:label="$t('vm.root.patients.patient.sphere.periodic_label')"/>

		<toggledate-frame v-if="sphere.periodic && !sphere.running" :id="`end-date-${elementId}`" 
			:from="sphere.event_date" :date='endDate' @input="updateEnd" :max-date="new Date()"
			:label="$t('vm.root.patients.patient.sphere.end_date.label')"
			:placeholder="$t('vm.root.patients.patient.sphere.end_date.placeholder')" />
	</div>

	<custom-form v-for="form in forms" :key="form.id" :form="form"/>

	<div class="text-right" v-if="isMainUser && canDelete">
		<delete-item class="btn btn--link-like text-danger" :can-delete="true"
			:delete-action="submitDelete">
			{{ $t('general.delete.text') }}
		</delete-item>
	</div>
</div>